import { render, staticRenderFns } from "./DienNuocNhaNuoc.vue?vue&type=template&id=d7c35896&scoped=true"
import script from "./DienNuocNhaNuoc.vue?vue&type=script&lang=js"
export * from "./DienNuocNhaNuoc.vue?vue&type=script&lang=js"
import style0 from "./DienNuocNhaNuoc.vue?vue&type=style&index=0&id=d7c35896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c35896",
  null
  
)

export default component.exports